import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  planRowWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    boxSizing: 'border-box',
  },
  plansHeading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  title: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.palette.labraText.description,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: theme.spacing(3),
    marginBottom: theme.spacing(-1),
  },
  planSelect: {
    marginTop: theme.spacing(2.5),
    minWidth: theme.spacing(31),
  },
  content: {
    fontSize: '14px',
    lineHeight: '20px',
    paddingTop: theme.spacing(2),
    color: theme.palette.labraText.primary,
  },
  tcv: {
    width: theme.spacing(35.875),
  },
  discountedTcv: {
    height: theme.spacing(5.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  divider: {
    marginBottom: theme.spacing(-1),
  },
}))
